<mat-icon *ngIf="data.attribute?.configs?.sparkling">check</mat-icon>
